import { createContext } from 'react';
// 系统设置
export default createContext();
